import * as yup from 'yup'

const formSchema = yup.object().shape({
  confirmationCode: yup.string().required('This field is required'),
})

export { formSchema }
